import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  TopToolbar,
  EditButton,
} from 'react-admin';

const BillerMerchantCodeMappingShowActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

const BillerMerchantCodeMappingShow = () => {
  return (
    <Show actions={<BillerMerchantCodeMappingShowActions />}>
      <SimpleShowLayout>
        <TextField label="ID" source="id" />
        <TextField label="Category ID" source="categoryId" />
        <TextField label="Category Name" source="categoryName" />
        <TextField label="Merchant Code" source="merchantCode" />
        <DateField label="Created At" source="createdAt" showTime />
        <DateField label="Updated At" source="updatedAt" showTime />
      </SimpleShowLayout>
    </Show>
  );
};

export default BillerMerchantCodeMappingShow;
